{
  "user": {
    "form": {
      "addTitle": "उपयोगकर्ता बनाएँ",
      "editTitle": "उपयोगकर्ता संपादित करें",
      "fields": {
        "username": "उपयोगकर्ता नाम",
        "email": "ईमेल",
        "fullName": "पूरा नाम",
        "password": "पासवर्ड",
        "confirmPassword": "पासवर्ड की पुष्टि करें",
        "facility": "सुविधा",
        "roles": "भूमिकाएँ",
        "active": "सक्रिय",
        "allFacilities": "सभी सुविधाएँ (पूरे हेल्थ सिस्टम में)",
        "globalAccessAck": "मैं समझता/समझती हूँ कि इससे हर सुविधा तक पहुँच मिलती है",
        "departments": "विभाग",
        "primaryDepartment": "प्राथमिक",
        "roleFacility": "{{role}} के लिए सुविधा",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ एक और सुविधा",
        "removeFacilityFromRole": "एक हटाएँ",
        "otherRoles": "अन्य"
      },
      "errors": {
        "usernameMin": "उपयोगकर्ता नाम कम से कम {{min}} वर्णों का होना चाहिए",
        "emailInvalid": "ईमेल पता अमान्य है",
        "passwordMin": "पासवर्ड कम से कम {{min}} वर्णों का होना चाहिए",
        "confirmPasswordRequired": "कृपया पासवर्ड की पुष्टि करें",
        "passwordMismatch": "पासवर्ड मेल नहीं खाते",
        "rolesRequired": "कम से कम एक भूमिका आवश्यक है",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "सहेजने से पहले पूरे हेल्थ सिस्टम की अनुमति की पुष्टि करें।"
      },
      "submit": {
        "create": "उपयोगकर्ता बनाएँ",
        "update": "उपयोगकर्ता अद्यतन करें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "उपयोगकर्ता सफलतापूर्वक बनाया गया",
        "updatedSuccess": "उपयोगकर्ता सफलतापूर्वक अद्यतन किया गया",
        "saveError": "उपयोगकर्ता सहेजने में विफल",
        "departmentsSaveError": "उपयोगकर्ता सहेजा गया, लेकिन विभाग असाइनमेंट विफल रहा। पुनः प्रयास के लिए संपादित करें।"
      },
      "globalAccessWarning": "इससे हर सुविधा के मरीज़ों तक पहुँच मिलती है, केवल पेजिंग दायरा नहीं। इसका उपयोग केवल वास्तव में पूरे हेल्थ सिस्टम के स्टाफ़ के लिए करें, जैसे ऑन-कॉल कवर।",
      "departmentsHint": "यह खाता जहाँ कार्य करता है। यह केवल संदर्भ और श्रेय है — इससे किसी रोगी तक पहुँच नहीं मिलती।",
      "noDepartments": "अभी तक कोई विभाग कॉन्फ़िगर नहीं किया गया है।"
    },
    "list": {
      "title": "उपयोगकर्ता प्रबंधन",
      "subtitle": "सिस्टम उपयोगकर्ता, भूमिकाएँ और एक्सेस प्रबंधित करें",
      "columns": {
        "username": "उपयोगकर्ता नाम",
        "fullName": "पूरा नाम",
        "email": "ईमेल",
        "roles": "भूमिकाएँ",
        "facility": "सुविधा",
        "status": "स्थिति",
        "lastLogin": "अंतिम लॉगिन",
        "actions": "क्रियाएँ",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "उपयोगकर्ता खोजें...",
        "allRoles": "सभी भूमिकाएँ",
        "allFacilities": "सभी सुविधाएँ",
        "allStatus": "सभी स्थितियाँ",
        "active": "सक्रिय",
        "inactive": "निष्क्रिय"
      },
      "actions": {
        "new": "उपयोगकर्ता बनाएँ",
        "editTitle": "उपयोगकर्ता संपादित करें",
        "resetPasswordTitle": "पासवर्ड रीसेट करें",
        "activate": "सक्रिय करें",
        "deactivate": "निष्क्रिय करें",
        "activateAria": "उपयोगकर्ता सक्रिय करें",
        "deactivateAria": "उपयोगकर्ता निष्क्रिय करें"
      },
      "lastLoginNever": "कभी नहीं",
      "empty": "आपके फ़िल्टर से मेल खाने वाला कोई उपयोगकर्ता नहीं मिला",
      "pagination": {
        "summary": "{{total}} में से {{from}}-{{to}} दिखा रहा है"
      },
      "toast": {
        "activated": "उपयोगकर्ता {{username}} सक्रिय किया गया",
        "deactivated": "उपयोगकर्ता {{username}} निष्क्रिय किया गया",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "सभी सुविधाएँ",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "locked": "लॉक",
      "pendingActivation": "सक्रियण लंबित"
    },
    "mfaStatus": {
      "enrolled": "नामांकित",
      "notEnrolled": "अनामांकित",
      "exempt": "छूट प्राप्त"
    }
  },
  "role": {
    "form": {
      "addTitle": "भूमिका बनाएँ",
      "editTitle": "भूमिका संपादित करें",
      "fields": {
        "name": "भूमिका का नाम",
        "code": "भूमिका कोड",
        "description": "विवरण",
        "category": "श्रेणी",
        "parentRole": "मूल भूमिका (अनुमतियाँ विरासत में लेती है)"
      },
      "options": {
        "none": "कोई नहीं"
      },
      "errors": {
        "nameRequired": "भूमिका का नाम आवश्यक है",
        "codeRequired": "भूमिका कोड आवश्यक है"
      },
      "submit": {
        "create": "भूमिका बनाएँ",
        "update": "भूमिका अद्यतन करें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "भूमिका सफलतापूर्वक बनाई गई",
        "updatedSuccess": "भूमिका सफलतापूर्वक अद्यतन की गई",
        "saveError": "भूमिका सहेजने में विफल"
      }
    },
    
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    },
    "source": {
      "own": "स्वयं",
      "inherited": "विरासत",
      "category": "श्रेणी"
    },
    "permissions": {
      "ownTitle": "अनुमतियाँ संपादित करें",
      "deniedTitle": "अस्वीकृत अनुमतियाँ संपादित करें",
      "ownSubtitle": "{{total}} में से {{granted}} प्रदत्त। विरासत और श्रेणी-डिफ़ॉल्ट अनुमतियाँ एक्सेस मैट्रिक्स में दिखाई जाती हैं; यह पृष्ठ केवल भूमिका के स्वयं के अनुदान प्रबंधित करता है।",
      "deniedSubtitle": "अस्वीकृत अनुमतियाँ भूमिका के स्वयं, मूल भूमिकाओं और श्रेणी डिफ़ॉल्ट से अनुदानों को रद्द करती हैं। इस भूमिका के लिए स्पष्ट रूप से अस्वीकार करने के लिए अनुमति का चयन करें।",
      "invalidRoleId": "भूमिका ID अमान्य है।",
      "save": "अनुमतियाँ सहेजें",
      "saveDenied": "अस्वीकृत अनुमतियाँ सहेजें",
      "cancel": "रद्द करें",
      "toast": {
        "updatedSuccess": "अनुमतियाँ अद्यतन की गईं",
        "deniedUpdatedSuccess": "अस्वीकृत अनुमतियाँ अद्यतन की गईं",
        "saveError": "अनुमतियाँ सहेजने में विफल",
        "saveDeniedError": "अस्वीकृत अनुमतियाँ सहेजने में विफल"
      },
      "permissionGroup": {
        "analytics": "विश्लेषण",
        "audit": "अंकेक्षण",
        "billing": "बिलिंग",
        "bloodProduct": "रक्त उत्पाद",
        "consent": "सहमति",
        "dietOrder": "आहार आदेश",
        "discharge": "डिस्चार्ज",
        "documentation": "दस्तावेज़ीकरण",
        "encounter": "मुलाकातें",
        "infection": "संक्रमण नियंत्रण",
        "licensing": "लाइसेंसिंग",
        "medication": "दवाएँ",
        "notification": "सूचनाएँ",
        "order": "आदेश",
        "patient": "रोगी",
        "referral": "रेफ़रल",
        "research": "अनुसंधान",
        "restraint": "अवरोध",
        "result": "परिणाम",
        "scheduling": "अनुसूचन",
        "system": "सिस्टम",
        "transfer": "स्थानांतरण",
        "user": "उपयोगकर्ता",
        "schedule": "अनुसूची",
        "admin": "प्रशासन",
        "report": "रिपोर्ट",
        "other": "अन्य"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "श्रेणी बनाएँ",
      "editTitle": "श्रेणी संपादित करें",
      "fields": {
        "name": "श्रेणी का नाम",
        "code": "श्रेणी कोड",
        "description": "विवरण",
        "sessionTimeout": "सत्र समयसीमा (मिनट)",
        "maxFailedLogins": "अधिकतम विफल लॉगिन",
        "mfaRequired": "इस श्रेणी के लिए MFA आवश्यक करें"
      },
      "placeholders": {
        "code": "जैसे CLINICAL"
      },
      "errors": {
        "nameRequired": "श्रेणी का नाम आवश्यक है",
        "codeRequired": "श्रेणी कोड आवश्यक है"
      },
      "submit": {
        "create": "श्रेणी बनाएँ",
        "update": "श्रेणी अपडेट करें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "श्रेणी बनाई गई",
        "updatedSuccess": "श्रेणी अपडेट की गई",
        "saveError": "श्रेणी सहेजने में विफल"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "कोई नहीं",
      "basic": "बुनियादी",
      "full": "पूर्ण",
      "paranoid": "अत्यधिक सख्त"
    },
    "permissions": {
      "title": "डिफ़ॉल्ट अनुमतियाँ",
      "titleWithName": "डिफ़ॉल्ट अनुमतियाँ — {{name}}",
      "subtitle": "इस श्रेणी की भूमिकाएँ इन अनुमतियों को विरासत में पाती हैं, जब तक कि स्पष्ट रूप से अस्वीकार न की जाएँ।",
      "invalidCategoryId": "श्रेणी ID अमान्य है।",
      "save": "डिफ़ॉल्ट अनुमतियाँ सहेजें",
      "cancel": "रद्द करें",
      "toast": {
        "updatedSuccess": "डिफ़ॉल्ट अनुमतियाँ अपडेट की गईं",
        "saveError": "डिफ़ॉल्ट अनुमतियाँ सहेजने में विफल"
      }
    }
  },
  "permission": {
    "action": {
      "view": "देखें",
      "viewSelf": "केवल स्वयं देखें",
      "viewRestricted": "प्रतिबंधित दृश्य",
      "read": "पढ़ें",
      "write": "लिखें",
      "create": "बनाएँ",
      "update": "अद्यतन करें",
      "modify": "संशोधित करें",
      "delete": "हटाएँ",
      "merge": "विलय",
      "discharge": "डिस्चार्ज",
      "transfer": "स्थानांतरण",
      "approve": "स्वीकृत करें",
      "cosign": "सह-हस्ताक्षर",
      "sign": "हस्ताक्षर",
      "plan": "योजना",
      "manage": "प्रबंधन",
      "all": "सभी",
      "breakGlass": "आपातकालीन पहुँच",
      "export": "निर्यात",
      "amend": "संशोधन",
      "administer": "देना",
      "doubleCheck": "द्विगुण जाँच",
      "reconcile": "मेल मिलान",
      "verbalVerify": "मौखिक आदेश पुष्टि",
      "verify": "सत्यापित करें",
      "acknowledge": "स्वीकार करें",
      "prescribe": "नुस्ख़ा",
      "dispense": "वितरण",
      "cancel": "रद्द करें",
      "users": "उपयोगकर्ता",
      "roles": "भूमिकाएँ",
      "facilities": "सुविधाएँ",
      "system": "सिस्टम",
      "audit": "अंकेक्षण लॉग"
    }
  },
  "access": {
    "title": "एक्सेस मैट्रिक्स",
    "subtitle": "भूमिकाएँ × अनुमतियाँ ग्रिड",
    "searchPermission": "अनुमतियाँ खोजें…",
    "searchRole": "भूमिकाएँ खोजें…",
    "categoryFilter": "श्रेणी",
    "legend": {
      "own": "स्वयं",
      "inherited": "विरासत",
      "category": "श्रेणी",
      "denied": "अस्वीकृत",
      "none": "कोई नहीं"
    },
    "cellTooltip": {
      "hasOwn": "सीधे प्रदान की गई",
      "hasInherited": "पैरेंट भूमिका से विरासत में: {{source}}",
      "hasCategory": "श्रेणी के माध्यम से प्रदान: {{source}}",
      "denied": "स्पष्ट रूप से अस्वीकृत",
      "none": "प्रदान नहीं की गई"
    },
    "inheritedFrom": "{{source}} से विरासत में",
    "bulkEdit": {
      "title": "बल्क संपादन",
      "applyTo": "चयनित पर लागू करें",
      "selectedPermissions": "{{count}} अनुमति(याँ)",
      "selectedRoles": "{{count}} भूमिका(एँ)",
      "actionGrant": "प्रदान करें",
      "actionDeny": "अस्वीकार करें",
      "actionClear": "साफ़ करें",
      "save": "परिवर्तन सहेजें",
      "cancel": "रद्द करें"
    },
    "emptyRoles": "फ़िल्टर से मेल खाने वाली कोई भूमिका नहीं।",
    "emptyPermissions": "फ़िल्टर से मेल खाने वाली कोई अनुमति नहीं।",
    "loading": "एक्सेस मैट्रिक्स लोड हो रहा है…",
    "permissionColumn": "अनुमति",
    "rolePicker": {
      "trigger": "तुलना के लिए भूमिकाएँ चुनें",
      "filterPlaceholder": "भूमिकाएँ फ़िल्टर करें…",
      "empty": "मेल खाने वाली कोई भूमिका नहीं।",
      "groupAll": "सभी",
      "groupNone": "कोई नहीं",
      "footerSummary": "{{total}} में से {{count}} चयनित",
      "selectAll": "सभी चुनें",
      "clear": "साफ़ करें"
    },
    "empty": {
      "selectRolesPrompt": "तुलना के लिए कम से कम एक भूमिका चुनें।",
      "selectAllRoles": "सभी भूमिकाएँ चुनें",
      "noPermissions": "कोई अनुमति नहीं मिली।"
    },
    "legendCategoryDefault": "श्रेणी डिफ़ॉल्ट",
    "legendNotGranted": "प्रदान नहीं की गई",
    "page": {
      "title": "एक्सेस मैट्रिक्स",
      "subtitle": "भूमिकाएँ, अनुमतियाँ और एक्सेस नीतियाँ देखें और प्रबंधित करें"
    },
    "tabs": {
      "matrix": "एक्सेस मैट्रिक्स",
      "roles": "भूमिका प्रबंधन",
      "categories": "श्रेणी प्रबंधन"
    },
    "roles": {
      "searchPlaceholder": "भूमिकाएँ या अनुमतियाँ खोजें...",
      "createButton": "भूमिका बनाएँ",
      "columns": {
        "role": "भूमिका",
        "category": "श्रेणी",
        "parent": "पैरेंट",
        "permissions": "अनुमतियाँ",
        "users": "उपयोगकर्ता",
        "actions": "क्रियाएँ"
      },
      "systemBadge": "सिस्टम",
      "managePermissionsTitle": "अनुमतियाँ प्रबंधित करें",
      "manageDeniedTitle": "अस्वीकृत अनुमतियाँ प्रबंधित करें",
      "deniedBadge": "अस्वीकृत",
      "editTitle": "भूमिका संपादित करें",
      "deleteTitle": "भूमिका हटाएँ",
      "expandAria": "भूमिका विस्तृत करें",
      "collapseAria": "भूमिका संक्षिप्त करें",
      "effectivePermissions": "प्रभावी अनुमतियाँ",
      "noPermissionsAssigned": "कोई अनुमति नहीं सौंपी गई।",
      "empty": "कोई भूमिका नहीं मिली।",
      "delete": {
        "title": "भूमिका हटाएँ",
        "description": "क्या आप वाकई भूमिका \"{{name}}\" हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
        "confirm": "हटाएँ"
      },
      "toast": {
        "deleted": "भूमिका हटाई गई",
        "deleteError": "भूमिका हटाने में विफल"
      }
    },
    "categories": {
      "subtitle": "श्रेणियाँ भूमिकाओं को समूहीकृत करती हैं और साझा नीतियाँ (MFA, सत्र सीमाएँ) परिभाषित करती हैं।",
      "createButton": "श्रेणी बनाएँ",
      "requireMfa": "MFA आवश्यक",
      "yes": "हाँ",
      "no": "नहीं",
      "sessionTimeout": "सत्र समय-सीमा",
      "sessionTimeoutMinutes": "{{count}} मिनट",
      "maxFailedLogins": "अधिकतम विफल लॉगिन",
      "manageDefaults": "डिफ़ॉल्ट अनुमतियाँ प्रबंधित करें",
      "editTitle": "संपादित करें",
      "editAria": "श्रेणी संपादित करें",
      "deleteTitle": "हटाएँ",
      "deleteAria": "श्रेणी हटाएँ",
      "empty": "अभी तक कोई श्रेणी परिभाषित नहीं की गई है।",
      "delete": {
        "title": "श्रेणी हटाएँ",
        "description": "क्या आप वाकई श्रेणी \"{{name}}\" हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
        "confirm": "हटाएँ"
      },
      "toast": {
        "deleted": "श्रेणी हटाई गई",
        "deleteError": "श्रेणी हटाने में विफल"
      }
    },
    "confirm": {
      "bulkApply": "{{count}} परिवर्तन को {{roleCount}} भूमिका(ओं) पर लागू करें?",
      "discardChanges": "सहेजे न गए परिवर्तन छोड़ें?"
    },
    "popover": {
      "grantTitle": "अनुमति प्रदान करें",
      "denyTitle": "अनुमति अस्वीकार करें",
      "clearTitle": "अनुमति साफ़ करें",
      "grantNote": "यह अनुमति प्रदान करने से विरासत में मिली अस्वीकृति अधिलिखित हो जाती है।",
      "denyNote": "यह अनुमति अस्वीकार करने से विरासत में मिली स्वीकृति अधिलिखित हो जाती है।",
      "clearNote": "साफ़ करने पर विरासत में मिले व्यवहार पर वापस लौट जाता है।"
    },
    "toast": {
      "permissionGranted": "अनुमति प्रदान की गई",
      "permissionDenied": "अनुमति अस्वीकृत",
      "permissionCleared": "अनुमति साफ़ की गई",
      "bulkApplied": "बल्क परिवर्तन लागू किए गए",
      "saveError": "परिवर्तन सहेजने में विफल"
    }
  },
  "confirm": {
    "restartIntegration": "\"{{name}}\" को पुनः आरंभ करें? नई TLS सामग्री लोड होने के दौरान सक्रिय कनेक्शन कुछ देर के लिए बंद हो जाएंगे।",
    "revokeFhirEndpoint": "\"{{name}}\" को निरस्त करें? इस एंडपॉइंट पर आउटबाउंड कॉल रुक जाएंगी।",
    "rotateSmartSecret": "\"{{name}}\" के लिए क्लाइंट सीक्रेट घुमाएँ? पुराना सीक्रेट तुरंत काम करना बंद कर देगा।",
    "revokeSmartApp": "\"{{name}}\" को निरस्त करें? इस ऐप से भविष्य के टोकन अनुरोध विफल हो जाएंगे।",
    "deactivateThirdPartyApp": "\"{{name}}\" को निष्क्रिय करें?"
  },
  "toast": {
    "tierCreated": "टियर बनाया गया",
    "tierCloned": "टियर क्लोन किया गया",
    "tierDeleted": "टियर हटाया गया",
    "tierStatusUpdated": "स्थिति अपडेट की गई",
    "tierFeaturesUpdated": "सुविधाएं अपडेट की गईं",
    "tierLimitsUpdated": "सीमाएं अपडेट की गईं",
    "tierSaveError": "टियर बनाने में विफल",
    "tierValidation": "नाम और कोड आवश्यक हैं",
    "licenseKeyGenerated": "लाइसेंस कुंजी उत्पन्न की गई",
    "licenseKeyCopied": "लाइसेंस कुंजी उत्पन्न की गई और क्लिपबोर्ड पर कॉपी की गई",
    "overridesSaved": "ओवरराइड सहेजे गए",
    "pricingConfigSaved": "कॉन्फ़िगरेशन सहेजा गया",
    "pricingPriceUpdated": "मूल्य अपडेट किया गया",
    "pricingRuleCreated": "मूल्य निर्धारण नियम बनाया गया",
    "addonUpdated": "ऐड-ऑन अपडेट किया गया",
    "invalidNumber": "कृपया एक मान्य संख्या दर्ज करें",
    "csvExported": "{{filename}} निर्यात किया गया",
    "integrationUpdated": "इंटीग्रेशन अपडेट किया गया",
    "integrationAdded": "इंटीग्रेशन जोड़ा गया",
    "integrationInvalidConfig": "अमान्य कॉन्फ़िगरेशन — होस्ट/पोर्ट और TLS फ़ील्ड जाँचें",
    "integrationDuplicateName": "उस नाम का एक इंटीग्रेशन पहले से मौजूद है",
    "integrationSaveFailed": "इंटीग्रेशन सहेजने में विफल",
    "smartAppRegistered": "SMART ऐप पंजीकृत किया गया",
    "smartAppRegisterFailed": "SMART ऐप पंजीकृत करने में विफल",
    "smartAppUpdated": "SMART ऐप अपडेट किया गया",
    "smartAppUpdateFailed": "SMART ऐप अपडेट करने में विफल",
    "fhirEndpointUpdated": "एंडपॉइंट अपडेट किया गया",
    "fhirEndpointRegistered": "एंडपॉइंट पंजीकृत किया गया",
    "fhirEndpointInvalidConfig": "अमान्य कॉन्फ़िगरेशन — base URL और auth फ़ील्ड जाँचें",
    "fhirEndpointDuplicateName": "उस नाम का एक एंडपॉइंट पहले से मौजूद है",
    "fhirEndpointSaveFailed": "एंडपॉइंट सहेजने में विफल",
    "clientIdCopied": "Client ID कॉपी किया गया",
    "clientSecretCopied": "Client secret कॉपी किया गया",
    "statusRefreshed": "स्थिति रिफ़्रेश की गई",
    "connTestOk": "कनेक्शन परीक्षण सफल",
    "connTestFailed": "कनेक्शन परीक्षण विफल - एंडपॉइंट कॉन्फ़िगरेशन जाँचें",
    "serverRestarted": "सर्वर पुनरारंभ हुआ — नया TLS सामग्री प्रभावी",
    "clientReconnected": "क्लाइंट पुनः कनेक्ट हुआ — नया TLS सामग्री प्रभावी",
    "notRunning": "नहीं चल रहा — कॉन्फ़िगरेशन लागू करने के लिए सर्वर/क्लाइंट प्रारंभ करें",
    "restartFailed": "एकीकरण पुनरारंभ विफल",
    "metadataOk": "/metadata ठीक{{detail}}",
    "metadataFailed": "/metadata विफल: {{error}}",
    "metadataProbeFailed": "/metadata जाँचने में विफल",
    "metadataUnknownError": "अज्ञात",
    "fhirRevoked": "FHIR एंडपॉइंट निरस्त",
    "fhirRevokeFailed": "एंडपॉइंट निरस्त करने में विफल",
    "smartRevoked": "SMART ऐप निरस्त",
    "smartRevokeFailed": "SMART ऐप निरस्त करने में विफल",
    "secretRotated": "क्लाइंट सीक्रेट घुमाया गया",
    "rotateSecretFailed": "सीक्रेट घुमाने में विफल",
    "messageRequeued": "संदेश पुनः प्रयास के लिए फिर से कतारबद्ध किया गया",
    "messageRetryFailed": "पुनः प्रयास विफल",
    "messageSkipped": "संदेश छोड़ा गया — कतार आगे बढ़ेगी",
    "messageSkipFailed": "छोड़ना विफल",
    "messageAbandoned": "संदेश छोड़ दिया गया",
    "messageAbandonFailed": "छोड़ देना विफल",
    "messageResent": "संदेश नए के रूप में पुनः भेजा गया",
    "messageResendFailed": "पुनः भेजना विफल",
    "reasonRequired": "कारण आवश्यक है",
    "copiedToClipboard": "क्लिपबोर्ड पर कॉपी किया गया",
    "thirdPartyAppCreated": "तृतीय-पक्ष ऐप सफलतापूर्वक बनाया गया",
    "thirdPartyAppUpdated": "तृतीय-पक्ष ऐप सफलतापूर्वक अपडेट किया गया",
    "thirdPartyAppDeactivated": "तृतीय-पक्ष ऐप निष्क्रिय किया गया",
    "thirdPartyAppLaunchUrl": "लॉन्च URL जनरेट किया गया: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "सुविधा जोड़ें",
      "editTitle": "सुविधा संपादित करें",
      "fields": {
        "name": "नाम",
        "code": "कोड",
        "type": "प्रकार",
        "address": "पता",
        "city": "शहर",
        "stateProvince": "राज्य/प्रांत",
        "country": "देश",
        "phone": "फ़ोन",
        "timeZone": "समय क्षेत्र",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "उदाहरण: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA समय क्षेत्र नाम (उदाहरण: Asia/Singapore)। रोगी गणना, MAR और रिपोर्ट में सुविधा-स्थानीय तिथियों के लिए उपयोग किया जाता है।"
      },
      "options": {
        "otherIana": "अन्य (IANA)…",
        "useCuratedList": "अनुशंसित सूची का उपयोग करें"
      },
      "errors": {
        "nameMin": "सुविधा का नाम कम से कम {{min}} वर्णों का होना चाहिए",
        "codeFormat": "कोड केवल बड़े अक्षरों और संख्याओं का होना चाहिए",
        "typeRequired": "सुविधा का प्रकार आवश्यक है",
        "countryRequired": "देश आवश्यक है",
        "timeZoneRequired": "समय क्षेत्र आवश्यक है",
        "timeZoneInvalidIana": "सर्वर ने इस समय क्षेत्र को अस्वीकार कर दिया। कृपया एक मान्य IANA नाम का उपयोग करें (उदाहरण: Asia/Singapore)।",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "बनाएँ",
        "update": "अद्यतन करें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "सुविधा सफलतापूर्वक बनाई गई",
        "updatedSuccess": "सुविधा सफलतापूर्वक अद्यतन की गई",
        "saveError": "सुविधा सहेजने में विफल",
        "invalidTimeZone": "अनुरोध अमान्य — कृपया जाँच करें कि समय क्षेत्र एक मान्य IANA नाम है (उदाहरण: Asia/Singapore)।"
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "सुविधा प्रबंधन",
      "subtitle": "सुविधाएँ, विभाग, और (इस ट्री के माध्यम से) भौतिक स्थान पदानुक्रम की एक झलक। पूर्ण स्थान ट्री (भवन → मंजिल → इकाई → कमरा → बेड) के लिए, <locationsLink>स्थान</locationsLink> देखें।",
      "columns": {
        "name": "नाम",
        "code": "कोड",
        "type": "प्रकार",
        "address": "पता",
        "phone": "फ़ोन",
        "depts": "विभाग",
        "status": "स्थिति",
        "actions": "कार्रवाई"
      },
      "filter": {
        "search": "सुविधाएँ खोजें..."
      },
      "actions": {
        "new": "सुविधा जोड़ें",
        "editTitle": "संपादित करें"
      },
      "expand": {
        "expand": "सुविधा का विस्तार करें",
        "collapse": "सुविधा को संक्षिप्त करें"
      },
      "empty": {
        "noMatch": "उस खोज से मेल खाने वाली कोई सुविधा नहीं है।",
        "none": "अभी तक कोई सुविधा नहीं — आरंभ करने के लिए सुविधा जोड़ें पर क्लिक करें।"
      },
      "departments": {
        "title": "विभाग",
        "add": "विभाग जोड़ें",
        "empty": "कोई विभाग कॉन्फ़िगर नहीं किया गया",
        "locationsCount": "{{count}} स्थान",
        "editTitle": "विभाग संपादित करें"
      },
      "locations": {
        "title": "स्थान",
        "add": "जोड़ें",
        "empty": "इस विभाग में कोई स्थान नहीं। स्थान ट्री (भवन → मंजिल → इकाई → बेड) का प्रबंधन <locationsLink>स्थान</locationsLink> में होता है।"
      }
    },
    "type": {
      "generalHospital": "सामान्य अस्पताल",
      "teachingHospital": "शिक्षण अस्पताल",
      "specialtyHospital": "विशेषज्ञता अस्पताल",
      "communityHospital": "सामुदायिक अस्पताल",
      "clinic": "क्लिनिक"
    },
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "हेल्थ सिस्टम जोड़ें",
      "editTitle": "हेल्थ सिस्टम संपादित करें",
      "subtitle": "संगठन संरचना का सर्वोच्च स्तर। एक या अधिक सुविधाओं की मूल इकाई।",
      "sections": {
        "identity": "पहचान",
        "primaryContact": "मुख्य संपर्क",
        "address": "पता"
      },
      "fields": {
        "code": "कोड",
        "name": "नाम",
        "taxId": "कर पहचान संख्या",
        "contactName": "नाम",
        "contactEmail": "ईमेल",
        "contactPhone": "फ़ोन",
        "addressLine1": "पता पंक्ति 1",
        "addressLine2": "पता पंक्ति 2",
        "city": "शहर",
        "stateProvince": "राज्य/प्रांत",
        "postalCode": "पिन कोड",
        "country": "देश",
        "active": "सक्रिय — निष्क्रिय करने के लिए चेकमार्क हटाएँ।"
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "कोड बनाने के बाद नहीं बदला जा सकता।"
      },
      "errors": {
        "codeRequired": "कोड आवश्यक है",
        "nameRequired": "नाम आवश्यक है"
      },
      "submit": {
        "create": "हेल्थ सिस्टम बनाएँ",
        "update": "परिवर्तन सहेजें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "हेल्थ सिस्टम बनाया गया",
        "updatedSuccess": "हेल्थ सिस्टम अपडेट किया गया",
        "saveError": "हेल्थ सिस्टम सहेजने में विफल",
        "codeConflict": "यह सिस्टम कोड पहले से मौजूद है",
        "invalidData": "हेल्थ सिस्टम डेटा अमान्य है"
      }
    },
    "list": {
      "title": "हेल्थ सिस्टम",
      "subtitle": "संगठन वृक्ष का शीर्ष — एंटरप्राइज़ / हेल्थ-सिस्टम मूल संगठन जो एक या अधिक सुविधाओं का स्वामी होते हैं। प्रारंभिक सेटअप के बाद शायद ही बदले जाते हैं।",
      "columns": {
        "name": "नाम",
        "code": "कोड",
        "contact": "संपर्क",
        "location": "स्थान",
        "facilities": "सुविधाएँ",
        "status": "स्थिति",
        "actions": "कार्रवाई"
      },
      "filter": {
        "search": "नाम या कोड से खोजें..."
      },
      "actions": {
        "new": "हेल्थ सिस्टम जोड़ें",
        "editTitle": "संपादित करें"
      },
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय"
      },
      "empty": {
        "noMatch": "उस खोज से मेल खाने वाला कोई हेल्थ सिस्टम नहीं है।",
        "none": "अभी तक कोई हेल्थ सिस्टम नहीं — आरंभ करने के लिए हेल्थ सिस्टम जोड़ें पर क्लिक करें।"
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "स्थान जोड़ें",
      "editTitle": "स्थान संपादित करें",
      "subtitle": "भौतिक स्थान — भवन, मंजिल, इकाई, कक्ष, या बिस्तर। FHIR R4 Location-संगत। पदानुक्रम वृक्ष बनाने के लिए मूल स्थान के माध्यम से नेस्ट करें।",
      "sections": {
        "hierarchy": "पदानुक्रम",
        "identity": "पहचान",
        "classification": "वर्गीकरण",
        "physicalAttributes": "भौतिक विशेषताएँ"
      },
      "fields": {
        "facility": "सुविधा",
        "parentLocation": "मूल स्थान",
        "department": "विभाग (वैकल्पिक)",
        "code": "कोड",
        "abbreviation": "संक्षिप्त रूप",
        "name": "नाम",
        "physicalType": "भौतिक प्रकार (FHIR)",
        "clinicalType": "क्लिनिकल प्रकार",
        "status": "स्थिति (FHIR)",
        "operationalStatus": "परिचालन स्थिति (HL7 0116)",
        "building": "भवन",
        "floor": "मंजिल",
        "wing": "विंग",
        "roomNumber": "कक्ष संख्या",
        "bedIdentifier": "बेड पहचानकर्ता",
        "capacity": "क्षमता",
        "active": "सक्रिय (लेगेसी फ़्लैग)"
      },
      "placeholders": {
        "facility": "सुविधा चुनें…",
        "parentNone": "कोई नहीं (शीर्ष-स्तर)",
        "departmentNone": "कोई नहीं",
        "code": "4W-12-A",
        "name": "4W-12 बिस्तर A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType मान सेट।",
        "clinicalType": "पुराना; service_type आने पर हटाएं।"
      },
      "physicalAttributes": {
        "show": "दिखाएँ ▾",
        "hide": "छिपाएँ ▴"
      },
      "errors": {
        "facilityRequired": "सुविधा आवश्यक है",
        "codeRequired": "कोड आवश्यक है",
        "nameRequired": "नाम आवश्यक है"
      },
      "submit": {
        "create": "स्थान बनाएँ",
        "update": "परिवर्तन सहेजें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "स्थान बनाया गया",
        "updatedSuccess": "स्थान अपडेट किया गया",
        "saveError": "स्थान सहेजने में विफल",
        "codeConflict": "यह स्थान कोड पहले से मौजूद है",
        "invalidData": "स्थान डेटा अमान्य है"
      }
    },
    "list": {
      "title": "स्थान पदानुक्रम",
      "subtitle": "भौतिक वृक्ष: भवन → मंज़िल → इकाई → कक्ष → बिस्तर। FHIR LocationPhysicalType के अनुरूप। अधिभोग चक्रित करने हेतु बिस्तर की स्थिति बैज पर क्लिक करें। सुविधाएँ और विभाग <facilitiesLink>सुविधाएँ</facilitiesLink> में प्रबंधित किए जाते हैं।",
      "filter": {
        "search": "नाम या कोड से खोजें...",
        "allFacilities": "सभी सुविधाएँ"
      },
      "actions": {
        "new": "स्थान जोड़ें",
        "addChildTitle": "उप-स्थान जोड़ें",
        "editTitle": "संपादित करें"
      },
      "expand": {
        "expand": "स्थान विस्तृत करें",
        "collapse": "स्थान संक्षिप्त करें"
      },
      "bed": {
        "toggleTitle": "{{next}} में बदलने हेतु क्लिक करें"
      },
      "empty": {
        "noMatch": "उस खोज से मेल खाने वाला कोई स्थान नहीं है।",
        "none": "इस सुविधा में अभी तक कोई स्थान नहीं है।"
      },
      "toast": {
        "bedStatusUpdated": "बिस्तर की स्थिति अद्यतन की गई",
        "bedStatusError": "बिस्तर की स्थिति अद्यतन करने में विफल"
      }
    },
    "type": {
      "si": "स्थल",
      "bu": "भवन",
      "wi": "विंग",
      "wa": "वार्ड",
      "lvl": "मंज़िल",
      "co": "गलियारा",
      "ro": "कक्ष",
      "bd": "बिस्तर",
      "ve": "वर्चुअल",
      "ho": "गृह",
      "ca": "कैबिनेट",
      "rd": "मार्ग",
      "area": "क्षेत्र",
      "jdn": "क्षेत्राधिकार"
    },
    "clinicalType": {
      "examRoom": "परीक्षा कक्ष",
      "inpatientBed": "भर्ती बिस्तर",
      "procedureRoom": "प्रक्रिया कक्ष",
      "icu": "ICU",
      "ed": "आपातकालीन",
      "or": "ऑपरेशन कक्ष",
      "virtual": "वर्चुअल"
    },
    "status": {
      "active": "सक्रिय",
      "suspended": "निलंबित",
      "inactive": "निष्क्रिय",
      "op": {
        "O": "अधिभोगित",
        "U": "रिक्त",
        "H": "साफ़-सफ़ाई",
        "K": "संदूषित",
        "I": "पृथक्कृत",
        "C": "बंद"
      }
    },
    "capability": {
      "isolation": "आइसोलेशन-सक्षम",
      "negativePressure": "ऋणात्मक दाब",
      "bariatric": "बेरिएट्रिक-सक्षम",
      "telemetry": "टेलीमेट्री-सक्षम",
      "icu": "ICU-स्तर"
    }
  },
  "department": {
    "form": {
      "addTitle": "विभाग जोड़ें",
      "editTitle": "विभाग संपादित करें",
      "subtitle": "सुविधा के भीतर संगठनात्मक इकाई। मूल विभाग के माध्यम से नेस्ट हो सकती है (जैसे, कार्डियोलॉजी → EP लैब)।",
      "sections": {
        "department": "विभाग"
      },
      "fields": {
        "facility": "सुविधा",
        "code": "कोड",
        "abbreviation": "संक्षिप्त नाम",
        "name": "नाम",
        "type": "प्रकार",
        "parentDepartment": "मूल विभाग",
        "costCenterCode": "लागत केंद्र कोड",
        "revenueDepartmentCode": "राजस्व विभाग कोड",
        "active": "सक्रिय — अनचेक करने पर सॉफ्ट-निष्क्रिय हो जाएगा।"
      },
      "placeholders": {
        "facility": "सुविधा चुनें…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "कार्डियोलॉजी",
        "parentNone": "कोई नहीं (शीर्ष स्तर)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "सुविधा आवश्यक है",
        "codeRequired": "कोड आवश्यक है",
        "nameRequired": "नाम आवश्यक है"
      },
      "submit": {
        "create": "विभाग बनाएँ",
        "update": "परिवर्तन सहेजें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "विभाग सफलतापूर्वक बनाया गया",
        "updatedSuccess": "विभाग सफलतापूर्वक अद्यतन किया गया",
        "saveError": "विभाग सहेजने में विफल",
        "codeConflict": "विभाग कोड पहले से मौजूद है",
        "invalidData": "अमान्य विभाग डेटा"
      }
    },
    "serviceType": {
      "clinical": "नैदानिक",
      "administrative": "प्रशासनिक",
      "support": "सहायक"
    },
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    }
  },
  "provider": {
    "form": {
      "addTitle": "चिकित्सक जोड़ें",
      "editTitle": "चिकित्सक संपादित करें",
      "fields": {
        "fullName": "पूरा नाम",
        "npi": "NPI",
        "providerType": "प्रदाता प्रकार",
        "credentials": "योग्यताएँ",
        "specialty": "विशेषज्ञता",
        "email": "ईमेल",
        "phone": "फ़ोन",
        "facilityAssignments": "सुविधा असाइनमेंट",
        "status": "स्थिति",
        "primaryFacility": "प्राथमिक सुविधा",
        "loginAccount": "लॉगिन खाता"
      },
      "placeholders": {
        "specialty": "विशेषज्ञता चुनें…",
        "credentials": "उदा. MD, FACC",
        "providerType": "प्रदाता प्रकार चुनें",
        "noLoginAccount": "कोई लॉगिन खाता नहीं"
      },
      "submit": {
        "create": "बनाएँ",
        "update": "अपडेट"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "चिकित्सक बनाया गया",
        "updatedSuccess": "चिकित्सक अपडेट किया गया",
        "saveError": "चिकित्सक सहेजने में विफल"
      },
      "hints": {
        "loginAccount": "इस चिकित्साकर्मी को उनके लॉगिन खाते से जोड़ता है। इसके बिना सह-हस्ताक्षर, फार्मासिस्ट सत्यापन और क्रिटिकल रिज़ल्ट स्वीकृति अस्वीकार हो जाएँगी।"
      }
    },
    "list": {
      "title": "प्रदाता प्रबंधन",
      "subtitle": "प्रदाताओं, क्रेडेंशियल और सुविधा असाइनमेंट का प्रबंधन करें",
      "columns": {
        "name": "नाम",
        "npi": "NPI",
        "specialty": "विशेषज्ञता",
        "credentials": "क्रेडेंशियल",
        "facilities": "सुविधाएँ",
        "status": "स्थिति",
        "actions": "क्रियाएँ"
      },
      "filter": {
        "search": "नाम, NPI, विशेषज्ञता से खोजें...",
        "allSpecialties": "सभी विशेषज्ञताएँ",
        "allFacilities": "सभी सुविधाएँ",
        "allStatus": "सभी स्थितियाँ"
      },
      "actions": {
        "new": "प्रदाता जोड़ें",
        "editTitle": "प्रदाता संपादित करें",
        "scheduleTitle": "अनुसूची टेम्पलेट",
        "viewCredentials": "क्रेडेंशियल देखें"
      },
      "credentials": {
        "licenseLabel": "लाइसेंस",
        "none": "कोई क्रेडेंशियल फ़ाइल में नहीं है"
      },
      "empty": "कोई प्रदाता नहीं मिला",
      "pagination": {
        "summary": "{{from}}-{{to}} में से {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "पिछला पृष्ठ",
        "next": "अगला पृष्ठ"
      },
      "toast": {
        "schedulePlaceholder": "अनुसूची टेम्पलेट लिंक (प्लेसहोल्डर)"
      },
      "noLogin": "लॉगिन नहीं",
      "noLoginHint": "इस प्रदाता का कोई लॉगिन खाता नहीं जुड़ा है, इसलिए वे सह-हस्ताक्षर, सत्यापन या स्वीकृति नहीं कर सकते।"
    },
    "specialty": {
      "internalMedicine": "आंतरिक चिकित्सा",
      "cardiology": "हृदय रोग विज्ञान",
      "emergencyMedicine": "आपातकालीन चिकित्सा",
      "pediatrics": "बाल रोग",
      "pathology": "विकृति विज्ञान",
      "obstetricsGynecology": "प्रसूति एवं स्त्री रोग",
      "surgery": "शल्य चिकित्सा",
      "orthopedics": "अस्थि रोग",
      "neurology": "तंत्रिका विज्ञान",
      "psychiatry": "मनोचिकित्सा",
      "radiology": "रेडियोलॉजी",
      "anesthesiology": "निश्चेतना विज्ञान",
      "oncology": "ऑन्कोलॉजी",
      "dermatology": "त्वचा विज्ञान",
      "ophthalmology": "नेत्र विज्ञान"
    },
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "onLeave": "छुट्टी पर"
    },
    "providerType": {
      "physician": "चिकित्सक",
      "nurse": "नर्स",
      "nursePractitioner": "नर्स प्रैक्टिशनर",
      "physicianAssistant": "चिकित्सक सहायक",
      "pharmacist": "फार्मासिस्ट",
      "therapist": "थेरेपिस्ट",
      "technician": "तकनीशियन",
      "other": "अन्य",
      "midwife": "दाई",
      "dentist": "दंत चिकित्सक",
      "pharmacyTechnician": "फार्मेसी तकनीशियन",
      "careAssistant": "नर्सिंग सहायक",
      "dietitian": "आहार विशेषज्ञ",
      "socialWorker": "सामाजिक कार्यकर्ता",
      "traditionalMedicine": "पारंपरिक चिकित्सा चिकित्सक"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "सेवा रेखा जोड़ें",
      "editTitle": "सेवा रेखा संपादित करें",
      "subtitle": "उच्च-स्तरीय चिकित्सीय समूह (हृदय-वाहिका, ऑन्कोलॉजी) जो विशिष्ट चिकित्सीय सेवाओं की मूल इकाई है।",
      "sections": {
        "serviceLine": "सेवा रेखा"
      },
      "fields": {
        "healthSystem": "स्वास्थ्य प्रणाली",
        "code": "कोड",
        "name": "नाम",
        "description": "विवरण",
        "active": "सक्रिय — सॉफ्ट-निष्क्रिय करने के लिए अनचेक करें।"
      },
      "placeholders": {
        "healthSystem": "स्वास्थ्य प्रणाली चुनें…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "संक्षिप्त विवरण — दायरा, रोग केंद्र, आदि।"
      },
      "errors": {
        "healthSystemRequired": "स्वास्थ्य प्रणाली आवश्यक है",
        "codeRequired": "कोड आवश्यक है",
        "nameRequired": "नाम आवश्यक है"
      },
      "submit": {
        "create": "सेवा रेखा बनाएं",
        "update": "परिवर्तन सहेजें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "सेवा रेखा बनाई गई",
        "updatedSuccess": "सेवा रेखा अद्यतन की गई",
        "saveError": "सेवा रेखा सहेजने में विफल",
        "codeConflict": "सेवा रेखा कोड पहले से मौजूद है",
        "invalidData": "अमान्य सेवा रेखा डेटा"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "चिकित्सीय सेवा जोड़ें",
      "editTitle": "चिकित्सीय सेवा संपादित करें",
      "subtitle": "विशिष्ट चिकित्सीय सेवा (कार्डियोलॉजी, EP लैब)। वैकल्पिक रूप से सेवा रेखा के अंतर्गत समूहीकृत + बिलिंग + निर्देशिका आउटपुट के लिए NUCC विशेषज्ञता कोड के साथ टैग किया जा सकता है।",
      "sections": {
        "clinicalService": "चिकित्सीय सेवा",
        "specialtyBilling": "विशेषज्ञता + बिलिंग"
      },
      "fields": {
        "code": "कोड",
        "name": "नाम",
        "serviceLine": "सेवा रेखा",
        "description": "विवरण",
        "specialtyCode": "NUCC विशेषज्ञता कोड",
        "specialtyDescription": "विशेषज्ञता विवरण",
        "revenueDepartmentCode": "राजस्व विभाग कोड",
        "active": "सक्रिय"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— कोई नहीं —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC वर्गीकरण — प्रदाता निर्देशिका + क्लेम प्रस्तुति को संचालित करता है।"
      },
      "errors": {
        "codeRequired": "कोड आवश्यक है",
        "nameRequired": "नाम आवश्यक है"
      },
      "submit": {
        "create": "चिकित्सीय सेवा बनाएं",
        "update": "परिवर्तन सहेजें"
      },
      "cancel": "रद्द करें",
      "toast": {
        "createdSuccess": "चिकित्सीय सेवा बनाई गई",
        "updatedSuccess": "चिकित्सीय सेवा अद्यतन की गई",
        "saveError": "चिकित्सीय सेवा सहेजने में विफल",
        "codeConflict": "चिकित्सीय सेवा कोड पहले से मौजूद है",
        "invalidData": "अमान्य चिकित्सीय सेवा डेटा"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "सेवा ↔ स्थान आवंटन",
    "subtitle": "कौन-सी नैदानिक सेवाएँ किन भौतिक स्थानों पर चलती हैं, वैकल्पिक दिन/समय विंडो और क्षमता के साथ। शेड्यूलिंग उपलब्ध स्लॉट बनाने के लिए इन्हें पढ़ती है। केवल सॉफ्ट-डिलीट — आवंटन समाप्त करने पर रिपोर्ट के लिए इतिहास संरक्षित रहता है।",
    "header": {
      "newAssignment": "नया आवंटन",
      "toggleCancel": "रद्द करें"
    },
    "form": {
      "title": "नया आवंटन",
      "fields": {
        "service": "नैदानिक सेवा",
        "location": "स्थान",
        "dayOfWeekPattern": "सप्ताह-दिवस पैटर्न",
        "startTime": "आरंभ समय",
        "endTime": "समाप्ति समय",
        "capacity": "क्षमता %",
        "notes": "टिप्पणियाँ",
        "isPrimary": "इस सेवा के लिए प्राथमिक स्थान"
      },
      "placeholders": {
        "service": "सेवा चुनें…",
        "location": "स्थान चुनें…",
        "dayOfWeekPattern": "1,3,5 (सोम/बुध/शुक्र)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "अल्पविराम-पृथक ISO सप्ताह-दिवस; रिक्त = प्रतिदिन।"
      },
      "errors": {
        "serviceLocationRequired": "सेवा और स्थान आवश्यक हैं"
      },
      "create": "बनाएं",
      "cancel": "रद्द करें"
    },
    "filter": {
      "allFacilities": "सभी सुविधाएँ",
      "allServices": "सभी सेवाएँ",
      "allLocations": "सभी स्थान",
      "allStatuses": "सभी स्थितियाँ",
      "searchService": "सेवाएँ खोजें…",
      "searchLocation": "स्थान खोजें…",
      "facility": "सुविधा",
      "serviceLine": "सेवा रेखा"
    },
    "columns": {
      "service": "सेवा",
      "location": "स्थान",
      "facility": "सुविधा",
      "when": "कब",
      "capacity": "क्षमता",
      "effective": "प्रभावी",
      "status": "स्थिति",
      "actions": "क्रियाएँ"
    },
    "status": {
      "active": "सक्रिय",
      "planned": "नियोजित",
      "suspended": "निलंबित",
      "ended": "समाप्त"
    },
    "dow": {
      "everyDay": "प्रतिदिन",
      "monFri": "सोम–शुक्र",
      "short": {
        "1": "सोम",
        "2": "मंगल",
        "3": "बुध",
        "4": "गुरु",
        "5": "शुक्र",
        "6": "शनि",
        "7": "रवि"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "प्राथमिक स्थान",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "प्राथमिक सेट करें",
      "unsetPrimary": "प्राथमिक हटाएँ",
      "endAssignment": "आवंटन समाप्त करें"
    },
    "bulkEdit": {
      "title": "थोक संपादन",
      "applyTo": "चयनित पर लागू करें",
      "selectedServices": "{{count}} सेवा(एँ)",
      "selectedLocations": "{{count}} स्थान",
      "save": "परिवर्तन सहेजें",
      "cancel": "रद्द करें"
    },
    "confirm": {
      "endTitle": "आवंटन समाप्त करें?",
      "endDescription": "{{service}} → {{location}}। समाप्त करने पर इतिहास संरक्षित रहता है किंतु यह युग्म सक्रिय शेड्यूलिंग से हटा दिया जाता है।",
      "endConfirm": "आवंटन समाप्त करें",
      "removeService": "{{location}} से {{service}} हटाएँ?",
      "makePrimary": "{{location}} को {{service}} का प्राथमिक स्थान बनाएँ?"
    },
    "toast": {
      "created": "आवंटन बनाया गया",
      "createError": "आवंटन बनाने में विफल",
      "ended": "आवंटन समाप्त किया गया",
      "endError": "आवंटन समाप्त करने में विफल",
      "primaryError": "प्राथमिक टॉगल करने में विफल",
      "updated": "आवंटन अद्यतन किया गया"
    },
    "empty": "इन फ़िल्टरों से मेल खाने वाला कोई आवंटन नहीं। जोड़ने के लिए नया आवंटन क्लिक करें।"
  },
  "integration": {
    "list": {
      "title": "एकीकरण प्रबंधन",
      "subtitle": "HL7, FHIR और तृतीय-पक्ष सिस्टम एकीकरण",
      "refresh": "रिफ़्रेश करें",
      "addEndpoint": "एंडपॉइंट जोड़ें",
      "searchPlaceholder": "एकीकरण खोजें…",
      "tabs": {
        "endpoints": "एंडपॉइंट",
        "messageLog": "संदेश लॉग",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "कुल एंडपॉइंट",
        "connected": "कनेक्टेड",
        "errors": "त्रुटियाँ",
        "totalMessages": "कुल संदेश"
      }
    },
    "columns": {
      "status": "स्थिति",
      "name": "नाम",
      "type": "प्रकार",
      "direction": "दिशा",
      "url": "URL",
      "tls": "TLS",
      "auth": "प्रमाणन",
      "lastMessage": "अंतिम संदेश",
      "messages": "संदेश",
      "errors": "त्रुटियाँ",
      "backlog": "बैकलॉग",
      "health": "स्वास्थ्य",
      "actions": "क्रियाएँ",
      "backlogTitle": "लंबित आउटबाउंड संदेश + सबसे पुराने लंबित की आयु",
      "healthTitle": "स्वास्थ्य स्थिति — यदि कतार किसी विफल संदेश पर अवरुद्ध है तो लाल"
    },
    "badge": {
      "tlsCerts": "प्रमाणपत्र: {{cert}}, कुंजी: {{key}}, CA: {{ca}}",
      "yes": "हाँ",
      "no": "नहीं",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "Bearer टोकन संग्रहीत",
      "bearerNoToken": "bearer (कोई टोकन सेट नहीं)",
      "mtlsCert": "mTLS क्लाइंट प्रमाणपत्र",
      "awaitingAck": "{{n}} ACK की प्रतीक्षा में",
      "oldest": "सबसे पुराना {{age}}",
      "never": "कभी नहीं",
      "blocked": "अवरुद्ध",
      "waiting": "प्रतीक्षारत",
      "ok": "ठीक",
      "blockedTitle": "एक विफल संदेश इस एकीकरण की कतार को अवरुद्ध कर रहा है। फ़िल्टर किया गया लॉग खोलने के लिए क्लिक करें।",
      "waitingTitle": "साझेदार से एन्हांस्ड-मोड ऐप ACK की प्रतीक्षा करते संदेश। फ़िल्टर किया गया लॉग खोलने के लिए क्लिक करें।",
      "okTitle": "सब ठीक — इस एकीकरण का संदेश लॉग खोलने के लिए क्लिक करें।",
      "receives": "प्राप्त करता है"
    },
    "action": {
      "testConnection": "कनेक्शन परीक्षण",
      "restartTls": "पुनरारंभ — नया रोटेट किया गया TLS लागू करें",
      "investigate": "थ्रूपुट, विलंबता और हाल की विफलताएँ",
      "edit": "संपादित करें"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "हाल के 50 संदेश",
      "columns": {
        "time": "समय",
        "id": "ID",
        "direction": "दिशा",
        "type": "प्रकार",
        "source": "स्रोत",
        "summary": "सारांश",
        "status": "स्थिति"
      },
      "dir": {
        "in": "इन",
        "out": "आउट"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 सर्वर स्थिति",
      "serverOnline": "सर्वर ऑनलाइन",
      "supportedResources": "समर्थित संसाधन",
      "version": "संस्करण",
      "externalHeader": "बाहरी FHIR एंडपॉइंट",
      "registerEndpoint": "एंडपॉइंट पंजीकृत करें",
      "columns": {
        "name": "नाम",
        "baseUrl": "आधार URL",
        "auth": "प्रमाणन",
        "status": "स्थिति",
        "lastChecked": "अंतिम जाँच",
        "actions": "क्रियाएँ"
      },
      "emptyEndpoints": "अभी तक कोई बाहरी FHIR एंडपॉइंट पंजीकृत नहीं है।",
      "revoked": "निरस्त",
      "statusOk": "ठीक",
      "statusError": "त्रुटि",
      "testMetadata": "/metadata परीक्षण",
      "edit": "संपादित करें",
      "revoke": "निरस्त करें"
    },
    "smart": {
      "header": "पंजीकृत SMART ऐप्स",
      "registerApp": "ऐप पंजीकृत करें",
      "columns": {
        "appName": "ऐप नाम",
        "clientId": "Client ID",
        "scopes": "स्कोप",
        "status": "स्थिति",
        "lastModified": "अंतिम संशोधन",
        "actions": "क्रियाएँ"
      },
      "emptyApps": "अभी तक कोई SMART ऐप पंजीकृत नहीं है।",
      "edit": "संपादित करें",
      "rotateSecret": "क्लाइंट सीक्रेट घुमाएँ",
      "revoke": "निरस्त करें"
    },
    "secretModal": {
      "title": "यह client secret अभी सहेजें",
      "body": "यह secret केवल एक बार दिखाया जाता है। यदि आप इसे खो देते हैं, तो नया जारी करने के लिए secret को रोटेट करें।",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID कॉपी करें",
      "copyClientSecret": "Client Secret कॉपी करें",
      "saved": "मैंने इसे सहेज लिया"
    },
    "drawer": {
      "header": "इंटिग्रेशन #{{id}}",
      "refresh": "रिफ़्रेश करें",
      "close": "बंद करें",
      "queueBlocked": "कतार अवरुद्ध",
      "queueBlockedBody": "एक विफल संदेश इस इंटिग्रेशन को भेजने से रोक रहा है। इसके बाद के संदेश तब तक प्रतीक्षा करेंगे जब तक कोई ऑपरेटर कार्रवाई नहीं करता।",
      "investigate": "जाँच करें",
      "tiles": {
        "backlog": "बैकलॉग",
        "success24h": "सफलता 24h",
        "avgLatency24h": "औसत विलंब 24h",
        "awaitingAck": "app-ACK की प्रतीक्षा"
      },
      "charts": {
        "throughput": "थ्रूपुट (24h)",
        "throughputSub": "प्रति घंटा बकेट। स्टैक्ड: आउटबाउंड पूर्ण + विफल; इनबाउंड द्वितीयक अक्ष पर।",
        "successRate": "सफलता दर (24h)",
        "successRateSub": "प्रति बकेट: पूर्ण / (पूर्ण + विफल)। रिक्तियाँ निष्क्रिय बकेट हैं।",
        "ackLatency": "ACK विलंब (24h)",
        "ackLatencySub": "भेजने और ACK प्राप्त होने के बीच का समय। avg ठोस है, p95 धराशायी।"
      },
      "series": {
        "outCompleted": "आउट · पूर्ण",
        "outFailed": "आउट · विफल",
        "inReceived": "इन · प्राप्त",
        "successPct": "सफलता %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "हाल की विफलताएँ",
      "viewAll": "सभी देखें →",
      "noFailures": "हाल की विंडो में कोई विफल संदेश नहीं। 🎉"
    }
  },
  "integrationStatus": {
    "connected": "कनेक्टेड",
    "disconnected": "डिस्कनेक्टेड",
    "error": "त्रुटि"
  },
  "integrationDirection": {
    "server": "सर्वर",
    "client": "क्लाइंट"
  },
  "messageStatus": {
    "sent": "भेजा गया",
    "received": "प्राप्त",
    "error": "त्रुटि",
    "acknowledged": "स्वीकृत"
  },
  "smartAppStatus": {
    "active": "सक्रिय",
    "revoked": "निरस्त"
  },
  "interfaceMessageStatus": {
    "pending": "लंबित",
    "processing": "प्रसंस्करण",
    "completed": "पूर्ण",
    "received": "प्राप्त",
    "processed": "संसाधित",
    "failed": "विफल",
    "error": "त्रुटि",
    "rejected": "अस्वीकृत",
    "deadLetter": "डेड लेटर",
    "skipped": "छोड़ा गया",
    "awaitingAppAck": "ऐप ACK की प्रतीक्षा"
  },
  "interfaceDirection": {
    "in": "इनबाउंड",
    "out": "आउटबाउंड"
  },
  "attemptOutcome": {
    "sent": "भेजा गया",
    "appNak": "ऐप NAK",
    "timeout": "समय समाप्त",
    "networkError": "नेटवर्क त्रुटि"
  },
  "fhirEndpoint": {
    "titleEdit": "FHIR एंडपॉइंट संपादित करें",
    "titleRegister": "FHIR एंडपॉइंट पंजीकृत करें",
    "subtitle": "बाहरी FHIR R4 पार्टनर जिनसे गेटवे आउटबाउंड संवाद करता है। इंटीग्रेशन सूची पर Test Connection बटन कॉन्फ़िगर किए गए auth + TLS के साथ <code>/metadata</code> की जाँच करता है।",
    "back": "वापस",
    "cancel": "रद्द करें",
    "storedBlank": "संग्रहीत — रखने के लिए खाली छोड़ें",
    "save": {
      "changes": "परिवर्तन सहेजें",
      "register": "एंडपॉइंट पंजीकृत करें"
    },
    "section": {
      "basics": "मूल बातें",
      "auth": "प्रमाणीकरण",
      "tls": "TLS"
    },
    "fields": {
      "name": "नाम",
      "baseUrl": "Base URL",
      "description": "विवरण",
      "active": "सक्रिय — सॉफ़्ट-रिवोक करने के लिए अनचेक करें।",
      "method": "विधि",
      "username": "उपयोगकर्ता नाम",
      "password": "पासवर्ड",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// आवश्यक है (विकास के लिए http://localhost स्वीकार्य है)। Test के दौरान अंत में /metadata स्वतः जोड़ा जाता है।",
      "oauth2": "OAuth2 टोकन फ़ेच एडमिन साइड पर कॉन्फ़िगर है; रनटाइम फ़ेचर बाद के अपडेट में आएगा। अभी, मान भरें और शेष कॉन्फ़िगरेशन सत्यापित करने के लिए Test चलाएँ।",
      "tls": "पार्टनर के सर्वर प्रमाणपत्र को पिन करने के लिए एक रूट CA पेस्ट करें, या mTLS के लिए client cert + key पेस्ट करें। ज्ञात CA के लिए केवल CA सिस्टम रूट स्टोर के साथ काम करता है।"
    },
    "option": {
      "method": {
        "none": "कोई नहीं",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — अधिकांश पार्टनर के लिए वैकल्पिक",
      "clientCertRequired": "Client certificate (PEM) — आवश्यक",
      "clientCertMtls": "Client certificate (PEM) — mTLS के लिए",
      "clientKeyRequired": "Client private key (PEM) — आवश्यक",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "नाम आवश्यक है",
      "baseUrlRequired": "Base URL आवश्यक है",
      "baseUrlInvalid": "बेस URL एक मान्य http(s) URL होना चाहिए",
      "basicUsername": "Basic auth के लिए उपयोगकर्ता नाम आवश्यक है",
      "basicPassword": "Basic auth के लिए पासवर्ड आवश्यक है",
      "bearerToken": "Bearer auth के लिए token आवश्यक है",
      "clientCertKey": "Client-certificate auth के लिए cert + key आवश्यक है"
    }
  },
  "smartApp": {
    "titleEdit": "SMART ऐप संपादित करें",
    "titleRegister": "SMART ऐप पंजीकृत करें",
    "subtitle": "SMART on FHIR क्लाइंट पंजीकरण। Client ID आपके लिए स्वचालित रूप से उत्पन्न होता है; client secret बनाने या रोटेट करने के बाद केवल एक बार दिखाया जाता है।",
    "back": "वापस",
    "cancel": "रद्द करें",
    "save": "परिवर्तन सहेजें",
    "register": "पंजीकृत करें",
    "fields": {
      "appName": "ऐप का नाम",
      "redirectUris": "रीडायरेक्ट URI",
      "scopes": "स्कोप",
      "launchUrl": "लॉन्च URL",
      "logoUrl": "लोगो URL",
      "active": "सक्रिय — इस ऐप को सॉफ्ट-रद्द करने के लिए चेक हटाएँ।"
    },
    "placeholder": {
      "appName": "मेरा EHR लॉन्चर"
    },
    "helper": {
      "redirectUris": "प्रति पंक्ति एक URI। https:// आवश्यक है (विकास के लिए http://localhost भी स्वीकार किया जाता है)।"
    },
    "secretModal": {
      "title": "यह client secret अभी सहेजें",
      "body": "यह secret केवल एक बार दिखाया जाता है। यदि आप इसे खो देते हैं, तो नया जारी करने के लिए secret को रोटेट करें।",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Client ID कॉपी करें",
      "copyClientSecret": "Client Secret कॉपी करें",
      "saved": "मैंने इसे सहेज लिया"
    },
    "validation": {
      "nameRequired": "नाम आवश्यक है",
      "redirectUriRequired": "कम से कम एक रीडायरेक्ट URI आवश्यक है",
      "scopeRequired": "कम से कम एक स्कोप आवश्यक है"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "इंटरफ़ेस संदेश लॉग",
      "subtitle": "प्रत्येक सक्रिय एकीकरण में इनबाउंड + आउटबाउंड HL7 संदेश।",
      "refresh": "रीफ़्रेश करें",
      "loading": "संदेश लोड हो रहे हैं…",
      "empty": "वर्तमान फ़िल्टर से मेल खाने वाला कोई संदेश नहीं।",
      "pagination": "{{total}} संदेश • {{pages}} में से पृष्ठ {{page}}",
      "prev": "पिछला",
      "next": "अगला",
      "archived": "(संग्रह)"
    },
    "relative": {
      "secondsAgo": "{{n}} सेकंड पहले",
      "minutesAgo": "{{n}} मिनट पहले",
      "hoursAgo": "{{n}} घंटे पहले"
    },
    "filter": {
      "header": "फ़िल्टर",
      "direction": "दिशा",
      "status": "स्थिति",
      "messageType": "संदेश प्रकार",
      "msh10": "MSH-10 शामिल है",
      "integrationId": "एकीकरण ID",
      "includeArchive": "संग्रह शामिल करें",
      "clear": "फ़िल्टर साफ़ करें",
      "any": "कोई भी",
      "messageTypePlaceholder": "उदा. ADT^A01",
      "controlIdPlaceholder": "नियंत्रण ID"
    },
    "columns": {
      "id": "ID",
      "dir": "दिशा",
      "integ": "एकीकरण",
      "type": "प्रकार",
      "msh10": "MSH-10",
      "status": "स्थिति",
      "ack": "ACK",
      "attempts": "प्रयास",
      "when": "कब"
    },
    "detail": {
      "eyebrow": "{{direction}} संदेश",
      "close": "बंद करें",
      "loading": "लोड हो रहा है…",
      "tabs": {
        "overview": "अवलोकन",
        "rawHl7": "रॉ HL7",
        "attempts": "प्रयास"
      },
      "operatorActions": "ऑपरेटर क्रियाएँ",
      "retry": "पुनः प्रयास",
      "skip": "छोड़ें",
      "abandon": "छोड़ दें",
      "resendAsNew": "नए के रूप में पुनः भेजें",
      "skipReason": "छोड़ने का कारण",
      "abandonReason": "छोड़ देने का कारण",
      "actionsHelper": "क्रियाएँ आपकी उपयोगकर्ता ID + कारण के साथ ऑडिट होती हैं। छोड़ें और छोड़ दें के लिए कारण आवश्यक है।",
      "overview": {
        "direction": "दिशा",
        "integration": "एकीकरण",
        "type": "प्रकार",
        "msh10": "MSH-10",
        "status": "स्थिति",
        "ackCode": "ACK कोड",
        "attempts": "प्रयास",
        "created": "निर्मित",
        "ackReceived": "ACK प्राप्त",
        "nextRetry": "अगला पुनः प्रयास",
        "ackText": "ACK टेक्स्ट",
        "lastError": "अंतिम त्रुटि",
        "sourceEventId": "स्रोत इवेंट ID"
      },
      "rawViewer": {
        "permissionDenied": "डिक्रिप्ट किए गए रॉ HL7 के लिए <code>INTERFACE_OPERATE</code> अनुमति आवश्यक है।",
        "notAvailable": "इस संदेश के लिए रॉ पेलोड उपलब्ध नहीं है।",
        "bytes": "{{bytes}} बाइट",
        "copy": "कॉपी"
      },
      "attempts": {
        "inboundInfo": "प्रयास इतिहास केवल आउटबाउंड संदेशों के लिए ट्रैक किया जाता है। इनबाउंड संदेश प्रति MSH-10 एक बार संसाधित होते हैं; पुनः प्रेषण नए प्रयास के बिना कैश किया गया ACK लौटाते हैं।",
        "totalAttempts": "कुल प्रयास",
        "nextAt": " ({{time}} पर अगला)",
        "refresh": "रिफ़्रेश",
        "loading": "प्रयास लोड हो रहे हैं…",
        "error": "प्रयास लोड करने में विफल।",
        "empty": "अभी तक कोई प्रयास दर्ज नहीं। वर्कर प्रति भेजने पर एक पंक्ति लिखता है; पहले क्लेम के बाद यह सूची भर जाती है।",
        "columns": {
          "when": "कब",
          "outcome": "परिणाम",
          "ack": "ACK",
          "duration": "अवधि",
          "detail": "विवरण"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "तृतीय-पक्ष एप्लिकेशन",
      "subtitle": "बाहरी एप्लिकेशन कॉन्फ़िगर करें जिन्हें VynaEMR से रोगी संदर्भ के साथ लॉन्च किया जा सकता है",
      "addApp": "एप्लिकेशन जोड़ें",
      "searchPlaceholder": "नाम, कोड या श्रेणी से ऐप्स खोजें...",
      "emptyTitle": "कोई एप्लिकेशन कॉन्फ़िगर नहीं किया गया",
      "emptyBody": "PACS व्यूअर, लैब पोर्टल या फ़ार्मेसी सिस्टम जैसे बाहरी एप्लिकेशन जोड़ें।",
      "columns": {
        "application": "एप्लिकेशन",
        "category": "श्रेणी",
        "url": "URL",
        "security": "सुरक्षा",
        "display": "प्रदर्शन",
        "status": "स्थिति",
        "actions": "क्रियाएँ"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT हस्ताक्षरित",
      "hmac": "HMAC",
      "hmacSigned": "HMAC हस्ताक्षरित",
      "none": "कोई नहीं",
      "chart": "चार्ट",
      "sidebar": "साइडबार",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    },
    "action": {
      "testLaunch": "टेस्ट लॉन्च",
      "edit": "संपादित करें",
      "deactivate": "निष्क्रिय करें"
    },
    "form": {
      "titleEdit": "एप्लिकेशन संपादित करें",
      "titleNew": "नया एप्लिकेशन",
      "fields": {
        "appCode": "ऐप कोड",
        "appName": "ऐप नाम",
        "category": "श्रेणी",
        "baseUrl": "बेस URL",
        "launchMethod": "लॉन्च विधि",
        "paramMappings": "पैरामीटर मैपिंग",
        "enableJwt": "JWT टोकन हस्ताक्षर सक्षम करें",
        "sharedSecret": "साझा रहस्य (JWT हस्ताक्षर कुंजी)",
        "enableHmac": "URL हस्ताक्षर सक्षम करें (HMAC)",
        "hmacKey": "HMAC कुंजी",
        "requiredPermission": "आवश्यक अनुमति",
        "displayOrder": "प्रदर्शन क्रम",
        "showInChart": "चार्ट में दिखाएँ",
        "showInSidebar": "साइडबार में दिखाएँ"
      },
      "placeholder": {
        "appCode": "उदा. pacs_viewer",
        "appName": "उदा. PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL पैराम नाम",
        "unchanged": "(अपरिवर्तित)",
        "sharedSecret": "साझा रहस्य दर्ज करें",
        "hmacKey": "HMAC कुंजी दर्ज करें",
        "requiredPermission": "उदा. RESULT_VIEW (खाली = कोई भी उपयोगकर्ता)"
      },
      "addParameter": "पैरामीटर जोड़ें",
      "cancel": "रद्द करें",
      "submitUpdate": "एप्लिकेशन अपडेट करें",
      "submitCreate": "एप्लिकेशन बनाएँ"
    },
    "paramSource": {
      "patientMrn": "रोगी MRN",
      "patientName": "रोगी का नाम",
      "patientDob": "रोगी DOB",
      "encounterId": "एनकाउंटर ID",
      "encounterNumber": "एनकाउंटर संख्या",
      "orderNumber": "ऑर्डर संख्या",
      "userName": "वर्तमान उपयोगकर्ता नाम",
      "userId": "वर्तमान उपयोगकर्ता ID",
      "timestamp": "वर्तमान टाइमस्टैम्प"
    },
    "launch": "{{name}} लॉन्च करें"
  },
  "integrationForm": {
    "titleEdit": "इंटीग्रेशन संपादित करें",
    "titleAdd": "इंटीग्रेशन जोड़ें",
    "subtitle": "VynaHL7 द्वारा समर्थित MLLP और HL7-over-HTTP इंटरफ़ेस। प्रमाणपत्र सामग्री इंटीग्रेशन पंक्ति पर संग्रहीत होती है; रोटेशन अगली बार सर्वर या क्लाइंट के पुनः आरंभ होने पर प्रभावी होते हैं।",
    "back": "वापस",
    "cancel": "रद्द करें",
    "saveChanges": "परिवर्तन सहेजें",
    "addIntegration": "इंटीग्रेशन जोड़ें",
    "storedBlank": "संग्रहीत — बनाए रखने के लिए खाली छोड़ें",
    "selectSibling": "— एक समकक्ष इंटीग्रेशन चुनें —",
    "section": {
      "basics": "मूल बातें",
      "connection": "कनेक्शन",
      "tls": "TLS / mTLS",
      "auth": "प्रमाणीकरण",
      "ackDelivery": "पावती और वितरण",
      "outboundRouting": "आउटबाउंड रूटिंग",
      "inboundTrust": "इनबाउंड विश्वास"
    },
    "fields": {
      "name": "नाम",
      "type": "प्रकार",
      "direction": "दिशा",
      "description": "विवरण",
      "active": "सक्रिय — इस इंटरफ़ेस को सॉफ़्ट-अक्षम करने के लिए अनचेक करें।",
      "host": "होस्ट",
      "port": "पोर्ट",
      "enableTls": "TLS सक्षम करें — उपयोग करता है",
      "serverCert": "सर्वर प्रमाणपत्र (PEM)",
      "clientCert": "क्लाइंट प्रमाणपत्र (PEM) — mTLS के लिए वैकल्पिक",
      "serverKey": "सर्वर निजी कुंजी (PEM)",
      "clientKey": "क्लाइंट निजी कुंजी (PEM)",
      "serverCa": "क्लाइंट CA विश्वास स्टोर (PEM) — mTLS के लिए",
      "clientCa": "सर्वर CA विश्वास स्टोर (PEM) — वैकल्पिक, सिस्टम रूट पर वापस आता है",
      "method": "विधि",
      "username": "उपयोगकर्ता नाम",
      "password": "पासवर्ड",
      "bearerToken": "Bearer टोकन",
      "inboundAck": "इनबाउंड ACK नीति",
      "outboundAck": "आउटबाउंड ACK नीति",
      "processingTimeout": "प्रसंस्करण टाइमआउट (मि.से.)",
      "pendingAckTtl": "लंबित ACK TTL (सेकंड)",
      "networkRetry": "नेटवर्क पुनः प्रयास अधिकतम",
      "appNakRetry": "ऐप NAK पुनः प्रयास अधिकतम",
      "reverseIntegration": "रिवर्स चैनल इंटीग्रेशन",
      "outboundTypes": "प्राप्त होने वाले संदेश प्रकार",
      "outboundEvents": "इवेंट-स्तरीय सदस्यताएँ",
      "receivingApplication": "प्राप्तकर्ता एप्लिकेशन (MSH-5)",
      "receivingFacility": "प्राप्तकर्ता सुविधा (MSH-6)",
      "inboundTrustProfile": "यह साझेदार कर सकता है"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "इस इंटरफ़ेस के बारे में संक्षिप्त नोट — स्वामी, उद्देश्य, संदेश प्रकार, आदि।",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "बाइंड पता। सभी इंटरफ़ेस पर सुनने के लिए 0.0.0.0 का उपयोग करें।",
      "hostClient": "वह दूरस्थ होस्ट जिससे इस क्लाइंट को कनेक्ट करना चाहिए।",
      "tlsHandshake": "हैंडशेक के लिए।",
      "authClientCert": "क्लाइंट प्रमाणपत्र/कुंजी ऊपर के TLS अनुभाग से आते हैं।",
      "authNone": "कोई HTTP प्रमाणीकरण हेडर संलग्न नहीं।",
      "authRs7": "{{call}} इसे हर आउटबाउंड अनुरोध में जोड़ता है।",
      "ackDefaults": "नियंत्रित करता है कि गेटवे इनबाउंड HL7 संदेशों को कैसे ACK करता है और आउटबाउंड भेजने पर प्रतिक्रिया ACK की व्याख्या कैसे करता है। डिफ़ॉल्ट मान",
      "ackDefaultsTail": "0.19.0 से पहले के व्यवहार से मेल खाते हैं — आवश्यकतानुसार प्रति पार्टनर बदलें।",
      "processingTimeout": "सिंक ऐप-ACK इनलाइन प्रसंस्करण की सीमा। टाइमआउट → AE + बैकग्राउंड कतार पुनः प्रयास।",
      "pendingAckTtl": "उन्नत-मोड ऐप-ACK प्रतीक्षा, इसके बाद स्वीपर इसे टाइमआउट कर देता है।",
      "networkRetry": "कतार अवरुद्ध होने से पहले परिवहन त्रुटियों के लिए पुनः प्रयास।",
      "appNakRetry": "AE/AR/CE/CR के लिए पुनः प्रयास — आमतौर पर 2–3 क्योंकि वही पेलोड पुनः प्रयास पर शायद ही सफल होता है।",
      "reverse": "उन्नत मोड पार्टनर के रिवर्स एंडपॉइंट की ओर इंगित एक समकक्ष इंटीग्रेशन के माध्यम से वास्तविक ऐप-ACK वितरित करता है। पहले समकक्ष को एक अलग इंटीग्रेशन पंक्ति के रूप में बनाएं, फिर इसे यहाँ लिंक करें।",
      "outboundRouting": "यह साझेदार क्या प्राप्त करता है। कुछ भी चयनित न होने का अर्थ है कि यह इंटरफ़ेस आउटबाउंड गंतव्य नहीं है और इसे कोई संदेश नहीं भेजा जाता।",
      "outboundEvents": "वैकल्पिक, अल्पविराम से अलग। पूरे प्रकार से अधिक सीमित — उस साझेदार के लिए जिसे केवल कुछ इवेंट चाहिए।",
      "receivingDefaults": "MSH-5 और MSH-6 यहाँ भेजे गए हर संदेश के प्राप्तकर्ता का नाम बताते हैं। खाली छोड़ने पर इंटरफ़ेस का नाम उपयोग होता है।",
      "inboundTrust": "यह साझेदार रोगी की पहचान के बारे में क्या दावा कर सकता है। प्रमाणीकरण बताता है कि कौन जुड़ रहा है; यह सेटिंग बताती है कि उन्हें हमें क्या बताने की अनुमति है। जब तक यह पीयर वास्तव में पंजीकरण मास्टर न हो, परिनियोजन डिफ़ॉल्ट पर छोड़ें।"
    },
    "option": {
      "type": {
        "mllp": "MLLP (TCP पर HL7 v2)",
        "hoh": "HoH (HTTPS पर HL7)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "क्लाइंट (आउटबाउंड)",
        "server": "सर्वर (इनबाउंड)"
      },
      "method": {
        "none": "कोई नहीं",
        "basic": "HTTP Basic",
        "bearer": "Bearer टोकन",
        "clientCert": "क्लाइंट प्रमाणपत्र (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "तुरंत AA (आज का डिफ़ॉल्ट)",
        "honorMsh16": "प्रति संदेश MSH-15/16 पढ़ें",
        "forceSync": "इनलाइन प्रोसेस करें, परिणाम पर AA/AE/AR",
        "forceEnhanced": "अभी CA + रिवर्स चैनल के माध्यम से ऐप-ACK"
      },
      "outbound": {
        "fireAndForget": "भेजें और भूल जाएँ (आज का डिफ़ॉल्ट)",
        "expectSync": "MSH-16=AL सेट करें, AE/AR पर पुनः प्रयास",
        "expectEnhanced": "CA की प्रतीक्षा करें + अनुवर्ती ऐप-ACK"
      }
    },
    "validation": {
      "nameRequired": "नाम आवश्यक है",
      "hostRequired": "होस्ट आवश्यक है",
      "mllpPort": "MLLP इंटीग्रेशन के लिए एक पोर्ट आवश्यक है",
      "portNumber": "पोर्ट एक संख्या होनी चाहिए",
      "tlsServerCertKey": "TLS सर्वर के लिए प्रमाणपत्र और कुंजी दोनों आवश्यक हैं",
      "basicUsername": "Basic प्रमाणीकरण के लिए उपयोगकर्ता नाम आवश्यक है",
      "basicPassword": "Basic प्रमाणीकरण के लिए पासवर्ड आवश्यक है",
      "bearerToken": "Bearer प्रमाणीकरण के लिए टोकन आवश्यक है",
      "enhancedReverse": "उन्नत ACK मोड के लिए एक रिवर्स इंटीग्रेशन आवश्यक है — नीचे एक चुनें।",
      "outboundEvent": "\"{{value}}\" ऐसा संदेश नहीं है जिसे यह सिस्टम भेजता है — ADT जैसा प्रकार या ADT^A01 जैसा इवेंट उपयोग करें।"
    },
    "trust": {
      "useDeploymentDefault": "परिनियोजन डिफ़ॉल्ट उपयोग करें",
      "observer": "पर्यवेक्षक — रोगी बनाता या बदलता नहीं",
      "demographics": "जनसांख्यिकी — मौजूदा रोगी को सुधार सकता है, मृत्यु सूचना सहित; बनाता नहीं",
      "registration": "पंजीकरण — रोगी बना भी सकता है और चार्ट मर्ज कर सकता है"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "इमेजिंग",
    "laboratory": "प्रयोगशाला",
    "pharmacy": "फ़ार्मेसी",
    "specialty": "विशेषज्ञता",
    "portal": "पोर्टल",
    "billing": "बिलिंग",
    "other": "अन्य"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "रीडायरेक्ट",
    "popup": "पॉपअप विंडो",
    "iframe": "iframe",
    "newTab": "नया टैब"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "CDS नियम संपादित करें",
      "titleCreate": "CDS नियम बनाएँ",
      "ruleName": "नियम का नाम",
      "ruleType": "नियम का प्रकार",
      "selectPlaceholder": "चुनें…",
      "severity": "गंभीरता",
      "triggerEvent": "ट्रिगर इवेंट",
      "actionType": "क्रिया प्रकार",
      "description": "विवरण",
      "active": "सक्रिय",
      "cancel": "रद्द करें",
      "submitUpdate": "नियम अद्यतन करें",
      "submitCreate": "नियम बनाएँ",
      "createdOk": "नियम सफलतापूर्वक बनाया गया",
      "createFailed": "नियम बनाने में विफल",
      "updatedOk": "नियम सफलतापूर्वक अद्यतन किया गया",
      "updateFailed": "नियम अद्यतन करने में विफल",
      "validation": {
        "nameRequired": "नियम का नाम आवश्यक है",
        "typeRequired": "नियम का प्रकार आवश्यक है",
        "descriptionRequired": "विवरण आवश्यक है",
        "triggerRequired": "ट्रिगर इवेंट आवश्यक है",
        "actionRequired": "क्रिया प्रकार आवश्यक है"
      }
    },
    "list": {
      "title": "CDS नियम",
      "subtitle": "नैदानिक निर्णय समर्थन नियम प्रबंधित करें",
      "addRule": "नियम जोड़ें",
      "loading": "CDS नियम लोड हो रहे हैं…",
      "loadError": "CDS नियम लोड करने में विफल।",
      "empty": "कोई CDS नियम कॉन्फ़िगर नहीं किया गया।",
      "columns": {
        "ruleName": "नियम नाम",
        "type": "प्रकार",
        "severity": "गंभीरता",
        "description": "विवरण",
        "status": "स्थिति",
        "actions": "क्रियाएँ"
      },
      "toggleActive": "निष्क्रिय करने के लिए क्लिक करें",
      "toggleInactive": "सक्रिय करने के लिए क्लिक करें",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "editRule": "नियम संपादित करें",
      "statusUpdated": "नियम स्थिति अपडेट की गई",
      "statusUpdateFailed": "नियम स्थिति अपडेट करने में विफल"
    }
  },
  "cdsSeverity": {
    "info": "जानकारी",
    "warning": "चेतावनी",
    "critical": "गंभीर"
  },
  "cdsTriggerEvent": {
    "orderSign": "ऑर्डर हस्ताक्षर",
    "orderSelect": "ऑर्डर चयन",
    "patientView": "रोगी दृश्य",
    "medicationPrescribe": "दवा निर्धारण",
    "resultReceived": "परिणाम प्राप्त",
    "patientAdmit": "रोगी भर्ती"
  },
  "cdsActionType": {
    "alert": "चेतावनी",
    "warning": "सावधानी",
    "hardStop": "कठोर रोक",
    "suggestion": "सुझाव",
    "notification": "अधिसूचना"
  },
  "cdsRuleType": {
    "drugInteraction": "औषधि अंतःक्रिया",
    "drugAllergy": "औषधि एलर्जी",
    "duplicateOrder": "डुप्लिकेट ऑर्डर",
    "custom": "कस्टम",
    "clinicalAlert": "नैदानिक चेतावनी",
    "sepsisScreen": "सेप्सिस स्क्रीनिंग"
  },
  "system": {
    "title": "सिस्टम कॉन्फ़िगरेशन",
    "subtitle": "एप्लिकेशन सेटिंग्स, सुरक्षा और सिस्टम स्वास्थ्य",
    "restartServices": "सेवाएँ पुनः आरंभ करें",
    "restartToast": "सेवाएँ पुनः आरंभ करें (प्लेसहोल्डर - पुष्टि आवश्यक है)",
    "loadError": "सिस्टम कॉन्फ़िगरेशन लोड करने में विफल",
    "section": {
      "systemInfo": "सिस्टम जानकारी",
      "systemInfoDesc": "संस्करण, अपटाइम और सेवा स्वास्थ्य",
      "general": "सामान्य सेटिंग्स",
      "generalDesc": "एप्लिकेशन नाम, समय क्षेत्र और ब्रांडिंग",
      "security": "सुरक्षा सेटिंग्स",
      "securityDesc": "पासवर्ड नीति, MFA और सत्र प्रबंधन",
      "notifications": "अधिसूचना सेटिंग्स",
      "notificationsDesc": "ईमेल और SMS गेटवे कॉन्फ़िगरेशन",
      "integration": "एकीकरण डिफ़ॉल्ट",
      "integrationDesc": "MLLP, FHIR और HL7 डिफ़ॉल्ट कॉन्फ़िगरेशन",
      "featureFlags": "फ़ीचर फ़्लैग",
      "featureFlagsDesc": "सिस्टम सुविधाएँ सक्षम या अक्षम करें",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "संस्करण",
      "uptime": "अपटाइम",
      "database": "डेटाबेस",
      "redis": "Redis",
      "microservices": "माइक्रोसेवाएँ",
      "conn": "कनेक्शन"
    },
    "uptime": {
      "running": "चल रहा है",
      "unknown": "अज्ञात",
      "up": "सक्रिय"
    },
    "subsection": {
      "passwordPolicy": "पासवर्ड नीति",
      "mfa": "बहु-कारक प्रमाणीकरण",
      "sessionLockout": "सत्र और लॉकआउट",
      "emailConfig": "ईमेल कॉन्फ़िगरेशन",
      "smsGateway": "SMS गेटवे",
      "mllpDefaults": "MLLP डिफ़ॉल्ट",
      "fhirConfig": "FHIR कॉन्फ़िगरेशन",
      "hl7Encoding": "HL7 v2 एन्कोडिंग"
    },
    "fields": {
      "appName": "एप्लिकेशन नाम",
      "timezone": "समय क्षेत्र",
      "dateFormat": "दिनांक प्रारूप",
      "supportEmail": "सहायता ईमेल",
      "logoUrl": "लोगो URL",
      "maintenanceMode": "रखरखाव मोड (उपयोगकर्ता पहुँच अक्षम करता है)",
      "upload": "अपलोड करें",
      "minPasswordLength": "न्यूनतम पासवर्ड लंबाई",
      "passwordExpiry": "पासवर्ड समाप्ति (दिन)",
      "requireUppercase": "बड़े अक्षर आवश्यक",
      "requireNumbers": "अंक आवश्यक",
      "requireSpecialChars": "विशेष वर्ण आवश्यक",
      "enableMfa": "MFA सक्षम करें",
      "mfaMethod": "MFA विधि",
      "sessionTimeout": "सत्र समय समाप्ति (मिनट)",
      "maxLoginAttempts": "अधिकतम लॉगिन प्रयास",
      "lockoutDuration": "लॉकआउट अवधि (मिनट)",
      "smtpHost": "SMTP होस्ट",
      "smtpPort": "SMTP पोर्ट",
      "smtpUser": "SMTP उपयोगकर्ता",
      "fromEmail": "प्रेषक ईमेल",
      "useTls": "TLS का उपयोग करें",
      "enabled": "सक्षम",
      "provider": "प्रदाता",
      "fromNumber": "प्रेषक नंबर",
      "defaultPort": "डिफ़ॉल्ट पोर्ट",
      "timeoutSeconds": "टाइमआउट (सेकंड)",
      "retryCount": "पुनः प्रयास गणना",
      "fhirBaseUrl": "FHIR बेस URL",
      "authMethod": "प्रमाणीकरण विधि",
      "fieldSeparator": "फ़ील्ड विभाजक",
      "encodingChars": "एन्कोडिंग वर्ण",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "एशिया/सिंगापुर (UTC+8)",
        "hongKong": "एशिया/हांगकांग (UTC+8)",
        "kualaLumpur": "एशिया/कुआलालंपुर (UTC+8)",
        "bangkok": "एशिया/बैंकॉक (UTC+7)",
        "tokyo": "एशिया/टोक्यो (UTC+9)",
        "kolkata": "एशिया/कोलकाता (UTC+5:30)",
        "sydney": "ऑस्ट्रेलिया/सिडनी (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (प्रमाणक ऐप)",
        "sms": "SMS",
        "email": "ईमेल"
      },
      "fhirAuth": {
        "none": "कोई नहीं",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "सामान्य सेटिंग्स सहेजें",
      "security": "सुरक्षा सेटिंग्स सहेजें",
      "notifications": "अधिसूचना सेटिंग्स सहेजें",
      "integration": "एकीकरण सहेजें",
      "features": "फ़ीचर फ़्लैग सहेजें",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "सामान्य",
      "security": "सुरक्षा",
      "notifications": "अधिसूचना",
      "integration": "एकीकरण",
      "features": "फ़ीचर फ़्लैग",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "लोगो अपलोड करें (प्लेसहोल्डर)",
      "saved": "{{section}} सेटिंग्स सफलतापूर्वक सहेजी गईं",
      "saveFailed": "सेटिंग्स सहेजने में विफल"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "रोगी विलय",
        "description": "रोगी विलय/विलय रद्द कार्यक्षमता सक्षम करें"
      },
      "breakGlass": {
        "label": "आपातकालीन पहुँच",
        "description": "प्रतिबंधित रिकॉर्ड के लिए आपातकालीन ओवरराइड की अनुमति दें"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "बाहरी सिस्टम के लिए FHIR R4 एंडपॉइंट उजागर करें"
      },
      "smartApps": {
        "label": "SMART on FHIR ऐप्स",
        "description": "तृतीय-पक्ष SMART ऐप्स को कनेक्ट करने की अनुमति दें"
      },
      "clinicalDecisionSupport": {
        "label": "क्लिनिकल निर्णय समर्थन",
        "description": "ऑर्डर एंट्री के लिए CDS हुक सक्षम करें"
      },
      "telemedicine": {
        "label": "टेलीमेडिसिन मॉड्यूल",
        "description": "वीडियो परामर्श और दूरस्थ निगरानी"
      },
      "patientPortal": {
        "label": "रोगी पोर्टल",
        "description": "रिकॉर्ड और अपॉइंटमेंट के लिए रोगी-सामना पोर्टल"
      },
      "analyticsDashboard": {
        "label": "एनालिटिक्स डैशबोर्ड",
        "description": "उन्नत एनालिटिक्स और रिपोर्टिंग डैशबोर्ड"
      },
      "medicationBarcode": {
        "label": "दवा बारकोड स्कैनिंग",
        "description": "दवा प्रशासन के लिए बारकोड सत्यापन"
      },
      "autoCoding": {
        "label": "स्वतः-कोडिंग (ICD/CPT)",
        "description": "AI-सहायता प्राप्त निदान और प्रक्रिया कोडिंग"
      }
    }
  },
  "audit": {
    "title": "ऑडिट लॉग",
    "subtitle": "विस्तृत परिवर्तन ट्रैकिंग के साथ सिस्टम गतिविधि लॉग",
    "exportCsv": "CSV निर्यात करें",
    "exportToast": "{{count}} ऑडिट प्रविष्टियाँ CSV के रूप में निर्यात की जा रही हैं (प्लेसहोल्डर)",
    "searchPlaceholder": "उपयोगकर्ता द्वारा खोजें…",
    "advanced": "उन्नत",
    "breakGlassOnly": "केवल आपातकालीन पहुँच",
    "fromTo": "से / तक:",
    "fromDate": "प्रारंभ तिथि",
    "toDate": "समाप्ति तिथि",
    "clearFilters": "सभी फ़िल्टर साफ़ करें",
    "entriesFound": "{{count}} प्रविष्टियाँ मिलीं",
    "noMatch": "आपके फ़िल्टर से कोई ऑडिट प्रविष्टि मेल नहीं खाती",
    "viewDetails": "विवरण देखें",
    "detail": {
      "title": "ऑडिट प्रविष्टि विवरण",
      "timestamp": "टाइमस्टैम्प",
      "user": "उपयोगकर्ता",
      "action": "कार्रवाई",
      "resource": "संसाधन",
      "ipAddress": "IP पता",
      "breakGlass": "आपातकालीन पहुँच",
      "yes": "हाँ",
      "no": "नहीं",
      "details": "विवरण",
      "dataChanges": "डेटा परिवर्तन",
      "before": "पहले",
      "after": "बाद में",
      "result": "परिणाम"
    },
    "columns": {
      "timestamp": "टाइमस्टैम्प",
      "user": "उपयोगकर्ता",
      "action": "कार्रवाई",
      "resource": "संसाधन",
      "resourceId": "संसाधन ID",
      "ipAddress": "IP पता",
      "details": "विवरण",
      "view": "देखें"
    },
    "filter": {
      "action": {
        "all": "सभी कार्रवाइयाँ",
        "create": "बनाएँ",
        "read": "पढ़ें",
        "update": "अपडेट करें",
        "delete": "हटाएँ",
        "login": "लॉगिन",
        "logout": "लॉगआउट",
        "export": "निर्यात",
        "breakGlass": "आपातकालीन पहुँच"
      },
      "resource": {
        "all": "सभी संसाधन",
        "patient": "रोगी",
        "encounter": "मुलाक़ात",
        "order": "ऑर्डर",
        "result": "परिणाम",
        "medication": "दवा",
        "user": "उपयोगकर्ता",
        "system": "सिस्टम"
      }
    },
    "pagination": {
      "first": "पहला",
      "last": "अंतिम",
      "pageOf": "पृष्ठ {{page}} / {{pages}}",
      "range": "{{total}} में से {{from}}-{{to}}"
    }
  },
  "taxonomy": {
    "title": "क्लिनिकल वर्गीकरण",
    "subtitle": "सेवा लाइनें संबंधित क्लिनिकल सेवाओं को समूहित करती हैं (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic)। दोनों शेड्यूलिंग में उपयोग होने वाले सेवा ↔ स्थान असाइनमेंट मैट्रिक्स में फीड होती हैं।",
    "addServiceLine": "सेवा लाइन जोड़ें",
    "addClinicalService": "क्लिनिकल सेवा जोड़ें",
    "tabs": {
      "serviceLines": "सेवा लाइनें",
      "clinicalServices": "क्लिनिकल सेवाएँ"
    },
    "searchLines": "सेवा लाइनें खोजें...",
    "searchServices": "क्लिनिकल सेवाएँ खोजें...",
    "empty": {
      "linesNone": "कोई सेवा लाइन कॉन्फ़िगर नहीं की गई।",
      "linesNoMatch": "कोई मेल खाती सेवा लाइन नहीं।",
      "servicesNone": "कोई क्लिनिकल सेवा कॉन्फ़िगर नहीं की गई।",
      "servicesNoMatch": "कोई मेल खाती क्लिनिकल सेवा नहीं।"
    },
    "columns": {
      "name": "नाम",
      "code": "कोड",
      "description": "विवरण",
      "services": "सेवाएँ",
      "status": "स्थिति",
      "serviceLine": "सेवा लाइन",
      "specialty": "विशेषता",
      "actions": "क्रियाएँ"
    },
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    },
    "editTitle": "संपादित करें"
  },
  "systemStatus": {
    "connected": "कनेक्ट किया गया",
    "error": "त्रुटि"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} नियुक्त",
      "unstaffedBadge": "कोई नियुक्त नहीं",
      "unstaffedWarning": "इन भूमिकाओं में कोई नियुक्त नहीं है, इसलिए वे स्तर किसी को नहीं बुलाएँगे: {{roles}}। एडमिन → उपयोगकर्ता में इस भूमिका को स्टाफ को सौंपें।"
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
